import type { AllRouteEndpoints } from "../routeTypes";
export const appSettingsInternalUserGroupsDeleteInternalUserGroupsCacheKeys: AllRouteEndpoints[] = [
  "/internal_user_groups/internal_user_groups_data_v2",
  "/internal_user_groups/internal_user_groups_data",
];
